query GetTickerBarDataById($slug: String, $tickerBarId: ID!) {
  tickerBarData: StreamToolsGetTickerBarDataById(slug: $slug, tickerBarId: $tickerBarId) {
    channel
    envelope
  }
}
